export function sendIframeHeight() {
  setTimeout(() => {
    window.parent.postMessage(
      { type: 'resize', height: document.body.scrollHeight },
      '*'
    );
  }, 1000);
}

export function sendIframeScrollToTop() {
  window.parent.postMessage({ type: 'scrollToTop' }, '*');
}

// Parent pages allowed to receive conversion-tracking messages. Never use '*'
// here; postMessage silently drops the message for non-matching parents.
const TRACKING_ORIGINS = ['https://www.teamtriton.com'];

const sentSubmissionIds = new Set();

// Tells the parent page a design request was saved, for Google Ads conversion
// tracking. Must only be called after the API confirms the request was saved.
// Do not add personal information to this message.
export function sendDesignRequestSuccess(sport, submissionId) {
  if (window.parent === window || !submissionId) return;
  if (sentSubmissionIds.has(submissionId)) return;
  sentSubmissionIds.add(submissionId);

  TRACKING_ORIGINS.forEach(origin => {
    window.parent.postMessage(
      {
        type: 'triton_design_request_success',
        sport,
        submissionId,
      },
      origin
    );
  });
}
